/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { Tabs } from 'antd-mobile'
import _ from 'lodash'
import { BET_MONEY_TYPE } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import { Models } from 'rmc-tabs/lib/Models'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
// css
import { UnderLineTabWrap } from '@styles/base.style'
import { SelectMonth } from '@styles/button.style'
import { GlobalStoreKey } from '@v2/constants/common'
import FriendsList from '../FriendsList'
import RewardList from '../RewardList'
import { AdvButton } from '@components/Button'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import dayjs from 'dayjs'

enum FRIENDS_INVITATION_TAB_KEY {
  G_MONEY = 'gmoney',
  DIA = 'dia',
}

const FriendsInvitationTab: React.FC = () => {

  const [currentDayjs, setCurrentDayjs] = useState(dayjs())
  const [year, setYear] = useState(null)
  const [month, setMonth] = useState(null)
  const [currentTabKey, setCurrentTabKey] = useState(FRIENDS_INVITATION_TAB_KEY.G_MONEY)

  const { globalStore, componentStore } = useRootStore()
  const { friendInvitationInvitor } = componentStore
  const gmoneyBettingSummary = _.find(friendInvitationInvitor?.invitedUsersBettingMoneySummary, targetObject => {
    return targetObject?.betMoneyType === BET_MONEY_TYPE.G_MONEY
  })?.membershipClubBettingMoney || 0
  const diaBettingSummary = _.find(friendInvitationInvitor?.invitedUsersBettingMoneySummary, targetObject => {
    return targetObject?.betMoneyType === BET_MONEY_TYPE.DIA
  })?.membershipClubBettingMoney || 0

  const claimablePastMonths = (_.toNumber(
      globalStore.findGlobalSetting(GlobalStoreKey.FRIEND_INVITATION_CLAIMABLE_PAST_MONTHS)?.value ?? 3)
  ) * -1
  const minYearAndMonth = dayjs().add(claimablePastMonths, 'month').format('YYYY-MM')
  const minPrevStartOfMonth = dayjs(minYearAndMonth).startOf('month')

  useOnMount(() => {
    const targetDayjs = dayjs().startOf('month')
    setCurrentDayjs(targetDayjs)
    setYear(targetDayjs.year())
    setMonth(targetDayjs.month() + 1)
  })

  useOnUnmount(() => {
    componentStore.setFriendInvitationInvitor(null)
  })

  const tabs = [
    {
      title:
        <Fragment>
          <span className="txt">G머니</span>
          <span className="num">{_.toNumber(gmoneyBettingSummary).toLocaleString()}</span>
        </Fragment>
      ,
      name: 'G머니',
      key: FRIENDS_INVITATION_TAB_KEY.G_MONEY,
    },
    {
      title:
        <Fragment>
          <span className="txt">다이아</span>
          <span className="num">{_.toNumber(diaBettingSummary).toLocaleString()}</span>
        </Fragment>
      ,
      name: '다이아',
      key: FRIENDS_INVITATION_TAB_KEY.DIA,
    },
  ]

  const isPreviousButtonDisabled = () => currentDayjs.toDate() <= minPrevStartOfMonth.toDate()
  const isNextButtonDisabled = () => dayjs().startOf('month').toDate() <= currentDayjs.toDate()

  const onClickPreviousButton = () => {
    if (isPreviousButtonDisabled()) {
      return
    }

    const addedCurrentDayjs = currentDayjs.add(-1, 'month')
    setCurrentDayjs(addedCurrentDayjs)
    setYear(addedCurrentDayjs.year())
    setMonth(addedCurrentDayjs.month() + 1)

    componentStore.fetchFriendInvitationInvitor(addedCurrentDayjs.toDate(), currentTabKeyToBetMoneyType())
      .catch(console.error)
  }

  const onClickNextButton = () => {
    if (isNextButtonDisabled()) {
      return
    }

    const addedCurrentDayjs = currentDayjs.add(1, 'month')
    setCurrentDayjs(addedCurrentDayjs)
    setYear(addedCurrentDayjs.year())
    setMonth(addedCurrentDayjs.month() + 1)

    componentStore.fetchFriendInvitationInvitor(addedCurrentDayjs.toDate(), currentTabKeyToBetMoneyType())
      .catch(console.error)
  }

  const onTabChanged = (tab: Models.TabData) => {
    setCurrentTabKey(tab.key as FRIENDS_INVITATION_TAB_KEY)
    componentStore.fetchFriendInvitationInvitor(currentDayjs.toDate(), currentTabKeyToBetMoneyType(tab.key))
      .catch(console.error)
  }

  // state 가 변경되기 전 호출할 경우 명시적으로 tabKey를 전달한다.
  const currentTabKeyToBetMoneyType = (tabKey: string = currentTabKey) => {
    let betMoneyType
    switch (tabKey) {
      case FRIENDS_INVITATION_TAB_KEY.G_MONEY:
        betMoneyType = BET_MONEY_TYPE.G_MONEY
        break
      case FRIENDS_INVITATION_TAB_KEY.DIA:
        betMoneyType = BET_MONEY_TYPE.DIA
        break
    }
    return betMoneyType
  }

  return (
    <Fragment>
      <SelectMonth isWhite>
        <AdvButton
          width={40}
          height={40}
          ico={<ArrowIco/>}
          icoColor="rgba(97, 95, 104, 100)"
          icoRotate={90}
          icoSize={12}
          className={`prev-btn ${isPreviousButtonDisabled() ? 'disabled' : ''}`}
          onClick={onClickPreviousButton}
        />
        <div className="date">{year}<span className="month">{month}월</span></div>
        <AdvButton
          width={40}
          height={40}
          ico={<ArrowIco/>}
          icoColor="rgba(97, 95, 104, 20)"
          icoRotate={-90}
          icoSize={12}
          className={`next-btn ${isNextButtonDisabled() ? 'disabled' : ''}`}
          onClick={onClickNextButton}
        />
      </SelectMonth>

      <UnderLineTabWrap className="friends-tab">
        <Tabs
          tabs={tabs}
          initialPage={0}
          onChange={onTabChanged}
          renderTabBar={tabProps => {
            return <Tabs.DefaultTabBar {...tabProps}/>
          }}
        />

        {/* 보상 리스트 */}
        <RewardList currentTabKey={currentTabKey}/>

        {/* 승부예측한 친구 리스트 */}
        <FriendsList/>

      </UnderLineTabWrap>
    </Fragment>
  )
}

export default observer(FriendsInvitationTab)
